import { atom } from 'recoil';

export const MobileNavigationState = atom<boolean>({
  key: 'MobileNavigationState',
  default: false,
})
